import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-move-right', 'IconArrowMoveRight', [
  ['path', { d: 'M11 12h10', key: 'svg-0' }],
  ['path', { d: 'M18 9l3 3l-3 3', key: 'svg-1' }],
  ['path', { d: 'M7 12a2 2 0 1 1 -4 0a2 2 0 0 1 4 0z', key: 'svg-2' }],
]);
